import React, {useState, useEffect} from "react";
import {getVendorType} from "../../../services/auth";
import SafeCall from "../../dashboard/components/modals/SafeCallModal";
import SafeCallComponent from "../../dashboard/components/lab-orders/LabOrderItem/children/SafeCallComponent";


const PharmacyOrderItem = (props) => {
    const {
        id,
        customer_contact_name,
        fa_status,
        jalali_created_at,
        order_insurance_price,
        order_regular_price,
        meta_data,
        prices
    } = props;
    const [samplerName ,setSamplerName] = useState("") 
    const vendor_type = getVendorType();
    useEffect(() => {
        if(vendor_type !=='DRUG') {
            if(meta_data !==undefined && meta_data !==null && Object.keys(meta_data).length !== 0) {
                const samplerNameM = (meta_data.sampler_name !== null && meta_data.sampler_name!== undefined) ? meta_data.sampler_name.value : '-'  
                setSamplerName(samplerNameM)
            }
        }
    }, [meta_data])
    const checkForSafeCall = () => {
        return <SafeCallComponent order={props} />
       /* if(vendor_type === "DRUG" && props.status === "order_delivered") {
            const dateTimeOfUpdated = props.updated_at.split('.')[0]
            const dateOfUpdated = dateTimeOfUpdated.split('T')[0]
            const timeOfUpdated = dateTimeOfUpdated.split('T')[1]
            const updatedYear = dateOfUpdated.split('-')[0]
            const updatedMonths = dateOfUpdated.split('-')[1]
            const updatedDay = dateOfUpdated.split('-')[2]
            let today = new Date();
            if(updatedYear == today.getFullYear() && updatedMonths == (today.getMonth() + 1)) {
                if((today.getDate() - updatedDay < 2)) {
                    return <SafeCallComponent  order={props} />
                } else if(today.getDate() - updatedDay === 2) {
                    if(today.getHours() <= timeOfUpdated.split(":")[0]){
                        return <SafeCallComponent order={props} />
                    } 
                }
            }
        }*/
    }
  return (
      <div className='order-item bg-white shadow-sm rounded'>
          <div className='order-id'>
              <div>#{id}</div>
              <div>{jalali_created_at}</div>
          </div>
          <div className='flex-row'>
              <div className='item-detail'>
                  <div className='key'>
                      نام مشتری :
                  </div>
                  <div className='value'>
                      {customer_contact_name}
                  </div>
              </div>
              <div className='item-detail'>
                  <div className='key'>
                      وضعیت :
                  </div>
                  {fa_status === "در انتظار پرداخت" ? (
                    <div className='value blue-value'>
                        {fa_status}
                    </div>
                  ) : (
                    <div className='value'>
                        {fa_status}
                    </div>
                  )}
              </div>
          </div>
          <div className='flex-row'>
              {vendor_type ==='DRUG' && (
                <div className='item-detail'>
                    <div className='key'>
                        هزینه با بیمه :
                    </div>
                    <div className='value'>
                        {order_insurance_price}
                    </div>
                </div>
              )}
              <div className='item-detail'>
                  <div className='key'>
                      هزینه بدون بیمه :
                  </div>
                  <div className='value'>
                      {order_regular_price}
                  </div>
              </div>
          </div>
          {vendor_type !=='DRUG' && (
            <div>
                <div className='flex-row'>
                    <div className='item-detail'>
                        <div className='key'>
                            نام خدمت:
                        </div>
                        <div className='value'>
                        {prices.length !==0 ? prices[0].title : '-'}
                        </div>
                    </div>
                </div>
                <div className='flex-row'>
                  <div className='item-detail'>
                        <div className='key'>
                            تعداد خدمت:
                        </div>
                        <div className='value'>
                            {prices.length !==0 ? prices[0].count : 0}
                        </div>
                    </div>
                    <div className='item-detail'>
                        <div className='key'>
                            نام پزشک/پرستار :
                        </div>
                        <div className='value'>
                            {samplerName}
                        </div>
                    </div>
                </div>
          </div>
          )}
        <div className="item-detail btn-safe-drug">
            {checkForSafeCall()}
        </div>
          <SafeCall />
      </div>
  )
};
export default PharmacyOrderItem;